<template>
    <jet-dialog-modal :show="show" @close="$emit('close')">
        <template #title>
            Email Preview
        </template>

        <template #content>
            <div class="text-sm text-gray-500">
                <!-- <div><strong>To:</strong> {{ emailData.to }}</div> -->
                <div><strong>Subject:</strong> {{ emailData.subject }}</div>
            </div>
            <div class="border p-4 mt-4 overflow-auto">
                <section style="background-color:#ffffff;">
                    <div style="background-color:#ffffff;">

                        <!-- EDM SECTION: CAN'T READ -->
                        <!--[if mso | IE]>
                    <table align="center" border="0" cellpadding="0" cellspacing="0" style="width:600px;" width="600">
                        <tr>
                        <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;">
                    <![endif]-->
                        <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:620px;">
                            <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation"
                                style="background:#ffffff;background-color:#ffffff;width:100%;">
                                <tbody>
                                    <tr>
                                        <td style="direction:ltr;font-size:0px;padding:0;text-align:center;">
                                            <!--[if mso | IE]>
                                <table role="presentation" border="0" cellpadding="0" cellspacing="0">
                                <tr>
                                    <td style="vertical-align:top;width:600px;">
                                <![endif]-->
                                            <div class="mj-column-per-100 mj-outlook-group-fix"
                                                style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                                                <table border="0" cellpadding="0" cellspacing="0" role="presentation"
                                                    style="vertical-align:top;" width="100%">
                                                    <tr>
                                                        <td align="center" class="txt_small"
                                                            style="font-size:0px;padding:25px 20px;word-break:break-word;">
                                                            <div
                                                                style="font-family:Helvetica,Arial,sans-serif;font-size:18px;line-height:1.3;text-align:center;color:#ffffff;">
                                                                <img src="https://toyota-brand-assets.s3-ap-southeast-1.amazonaws.com/toyota-edm-logo-850x850.jpg"
                                                                    alt="toyota-logo" width="64"></div>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <!--[if mso | IE]>
                                    </td>
                                </tr>
                                </table>
                                <![endif]-->
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!--[if mso | IE]>
                        </td>
                        </tr>
                    </table>
                    <![endif]-->
                        <!-- #end of EDM SECTION: CAN'T READ -->


                        <!-- EDM SECTION: HERO -->
                        <!--[if mso | IE]>
                    <table align="center" border="0" cellpadding="0" cellspacing="0" style="width:600px;" width="600">
                        <tr>
                        <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;">
                    <![endif]-->
                        <div style="margin:0 auto;max-width:620px;">
                            <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
                                <tr style="vertical-align:top;">
                                    <td style="width:0.01%;padding-bottom:27.419%;mso-padding-bottom-alt:0;"></td>
                                    <td class="hero_bg_img"
                                        style="background-image:url(https://toyota-brand-assets.s3-ap-southeast-1.amazonaws.com/banner-edm-broadcast.jpg);padding:0px;vertical-align:bottom;"
                                        background="https://toyota-brand-assets.s3-ap-southeast-1.amazonaws.com/banner-edm-broadcast.jpg"
                                        bgcolor="#292929" width="620" valign="bottom">
                                        <!--[if gte mso 9]>
                            <v:rect xmlns:v="urn:schemas-microsoft-com:vml" fill="true" stroke="false" style="width:620px;height:170px;">
                                <v:fill type="frame" src="https://toyota-brand-assets.s3-ap-southeast-1.amazonaws.com/banner-edm-broadcast.jpg" color="#292929" />
                                <v:textbox inset="0,0,0,0" style="v-text-anchor:bottom;">
                            <![endif]-->

                                        <!--[if gte mso 9]>
                                </v:textbox>
                            </v:rect>
                            <![endif]-->
                                    </td>
                                    <td style="width:0.01%;padding-bottom:27.419%;mso-padding-bottom-alt:0;"></td>
                                </tr>
                            </table>
                        </div>
                        <!--[if mso | IE]>
                        </td>
                        </tr>
                    </table>
                    <![endif]-->
                        <!-- #end of EDM SECTION: HERO -->


                        <!-- EDM SECTION: MAIN CONTENT -->
                        <!--[if mso | IE]>
                    <table align="center" border="0" cellpadding="0" cellspacing="0" style="width:600px;" width="600">
                        <tr>
                        <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;">
                    <![endif]-->
                        <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:620px;">
                            <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation"
                                style="background:#ffffff;background-color:#ffffff;width:100%;">
                                <tbody>
                                    <tr>
                                        <td style="direction:ltr;font-size:0px;padding:0;text-align:center;">
                                            <!--[if mso | IE]>
                                <table role="presentation" border="0" cellpadding="0" cellspacing="0">
                                <tr>
                                    <td style="vertical-align:top;width:598px;">
                                <![endif]-->
                                            <div class="mj-column-per-100 mj-outlook-group-fix"
                                                style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                                                <table border="0" cellpadding="0" cellspacing="0" role="presentation"
                                                    style="vertical-align:top;" width="100%">
                                                    <tr>
                                                        <td align="left" class="pad_sml sec_content"
                                                            style="font-size:0px;padding:30px 32px;word-break:break-word;">
                                                            <div
                                                                style="font-family:Helvetica,Arial,sans-serif;font-size:18px;line-height:1.3;text-align:left;color:#101010;">
                                                                <div style="margin:0 0 1.5em;white-space: pre-line"
                                                                    v-html="emailData.body"></div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <!--[if mso | IE]>
                                    </td>
                                </tr>
                                </table>
                                <![endif]-->
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!--[if mso | IE]>
                        </td>
                        </tr>
                    </table>
                    <![endif]-->
                        <!-- #end of EDM SECTION: MAIN CONTENT -->




                        <!-- EDM SECTION: FOOTER -->
                        <!--[if mso | IE]>
                    <table align="center" border="0" cellpadding="0" cellspacing="0" style="width:620px;" width="620">
                        <tr>
                        <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;">
                    <![endif]-->
                        <div style="margin:0px auto;max-width:620px;">
                            <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation"
                                style="width:100%;">
                                <tbody>
                                    <tr>
                                        <td style="direction:ltr;font-size:0px;padding:0;text-align:center;">
                                            <!--[if mso | IE]>
                                <table role="presentation" border="0" cellpadding="0" cellspacing="0">
                                <tr>
                                    <td style="vertical-align:top;width:600px;">
                                <![endif]-->
                                            <div class="mj-column-per-100 mj-outlook-group-fix"
                                                style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                                                <table border="0" cellpadding="0" cellspacing="0" role="presentation"
                                                    style="vertical-align:top;" width="100%">
                                                    <tr>
                                                        <td class="pad_copyright"
                                                            style="font-size:0px;padding:0 36px;word-break:break-word;">
                                                            <p
                                                                style="border-top:solid 1px #cccccc;font-size:1px;margin:0px auto;width:100%;">
                                                            </p>
                                                            <!--[if mso | IE]>
                                        <table align="center" border="0" cellpadding="0" cellspacing="0" style="border-top:solid 1px #cccccc;font-size:1px;margin:0px auto;width:528px;" role="presentation" width="528px">
                                        <tr>
                                            <td style="height:0;line-height:0;">&nbsp;</td>
                                        </tr>
                                        </table>
                                        <![endif]-->
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td align="left" class="pad_sml txt_small"
                                                            style="font-size:0px;padding:20px 36px;word-break:break-word;">
                                                            <div
                                                                style="font-family:Helvetica,Arial,sans-serif;font-size:18px;line-height:1.3;text-align:left;color:#3A3A3A;">
                                                                <p style="margin:0; text-align: center; color: #3A3A3A;"><small
                                                                        style="font-size:85%;">This is a system-generated email.
                                                                        Please do not reply.</small></p>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <!--[if mso | IE]>
                                    </td>
                                </tr>
                                </table>
                                <![endif]-->
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!--[if mso | IE]>
                        </td>
                        </tr>
                    </table>
                    <![endif]-->
                        <!-- #end of EDM SECTION: FOOTER -->

                    </div>
                </section>
            </div>
        </template>

        <template #footer>
            <jet-secondary-button @click="$emit('close')" class="mr-4">
                Close
            </jet-secondary-button>
            <jet-button :disabled="btnDisabled" @click="$emit('sendEmail')">
                Confirm
            </jet-button>
        </template>
    </jet-dialog-modal>
</template>

<script>
import JetDialogModal from '@/Jetstream/DialogModal';
import JetButton from '@/Jetstream/Button';
import JetSecondaryButton from '@/Jetstream/SecondaryButton';

export default {
    components: {
        JetDialogModal,
        JetButton,
        JetSecondaryButton,
    },

    props: {
        emailData: Object,
        show: Boolean,
        btnDisabled: Boolean,
    },

    emits: ['close', 'sendEmail'],
};
</script>

<style>
    section.email-content {
        font-family: Helvetica, Arial, sans-serif;
        line-height: 1.3;
        margin: 0;
        padding: 0;
        -webkit-text-size-adjust: 100%;
        -ms-text-size-adjust: 100%
    }

    #outlook a {
        padding: 0
    }

    table,
    td {
        border-collapse: collapse;
        mso-table-lspace: 0pt;
        mso-table-rspace: 0pt
    }

    img {
        border: 0;
        height: auto;
        line-height: 100%;
        outline: none;
        text-decoration: none;
        -ms-interpolation-mode: bicubic
    }

    p {
        display: block;
        margin: 13px 0
    }

    [owa] .mj-column-per-100 {
        width: 100% !important;
        max-width: 100%
    }

    [owa] .mj-column-per-33-333333333333336 {
        width: 33.333333333333336% !important;
        max-width: 33.333333333333336%
    }

    .hero_bg_img {
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
    }

    .txt_small div,
    .txt_small p {
        font-size: 14px !important
    }

    .explore_tiles .txt_small div {
        text-transform: uppercase !important
    }

    @media only screen and (min-width:481px) {
        .mj-column-per-100 {
            width: 100% !important;
            max-width: 100%
        }

        .mj-column-per-33-333333333333336 {
            width: 33.333333333333336% !important;
            max-width: 33.333333333333336%
        }
    }

    @media only screen and (max-width:480px) {
        h2 {
            font-size: 22px !important
        }

        table.mj-full-width-mobile {
            width: 100% !important
        }

        td.mj-full-width-mobile {
            width: 100% !important
        }

        .pad_sml {
            padding: 20px !important
        }

        .pad_sml_hdr {
            padding: 30px 20px 10px !important
        }

        .pad_copyright {
            padding: 0 20px !important
        }

        .hero_hdr,
        .hero_hdr h1 {
            font-size: 28px !important
        }

        .txt_small div,
        .txt_small p {
            font-size: 13px !important
        }

        .sec_content p {
            font-size: 16px !important
        }

        .explore_tiles>table>tbody>tr>td {
            padding: 0 8px 20px !important
        }
    }
    .sec_content ol,
    .sec_content ul {
        list-style: revert;
        margin: revert;
        padding: revert;
    }
</style>
